import { EResidentialComplexesIdsTypes } from '../../actions';
import { type TReduxActions } from '../../types/redux';

export function residentialComplexesIdsReducer(state: number[] = [], action: TReduxActions): number[] {
  switch (action.type) {
    case EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange:
      return action.payload;

    default:
      return state;
  }
}
